import { render, staticRenderFns } from "./orgEdit.vue?vue&type=template&id=73819468&scoped=true&"
import script from "./orgEdit.vue?vue&type=script&lang=js&"
export * from "./orgEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73819468",
  null
  
)

export default component.exports